import axios from 'axios';
import { Api_ENDPOINT, StoreLocatorAPI } from '../constant';

class ApiService {
PendingCalls = 0;

StoreLocatorURL;
headers;


  private static instance: ApiService;
  private isAuthenticated: boolean = false;

  private constructor() {
    this.headers= { Accept: 'application/json',"Content-Type": "application/json" };
    this.PendingCalls = 0;
  }

  public static getInstance(): ApiService {
    if (!ApiService.instance) {
      ApiService.instance = new ApiService();
    }
    return ApiService.instance;
  }


  //For Get
 public get = async (baseURL, endpoint, url, trackLoading: boolean = true) => {
      if (trackLoading) {
          this.ShowSpinner();
          this.PendingCalls++;
        }
  
      try {
        const response: any = await fetch(baseURL + endpoint, {method: 'GET', headers:{'Content-Type':'application/json'}})
          if (trackLoading) {
              this.PendingCalls--;
              this.HideSpinner();
            }
            const data = await response.json();
            return data;
        
      } catch (error) {
          if (trackLoading) {
              this.PendingCalls--;
              this.HideSpinner();
            }
      }
  };
  
  //For Post
  public post = async (baseURL, endpoint, req: any, trackLoading: boolean = true) => {
    
        try {
          const response: any = await fetch(baseURL + endpoint, {method: 'POST', headers:{'Content-Type':'application/json', "APIKey": '68a3b7b3-0cd6-4c6b-825e-1f58ad449422'}, body: JSON.stringify(req)});          
          if (trackLoading) {
            this.PendingCalls--;
              this.HideSpinner();
            }
            const data = await response.json();
            return data;
      
      } catch (error) {        
          if (trackLoading) {
            this.PendingCalls--;
              this.HideSpinner();
            }        
      }
  };

 

public postFrom = async (baseUrl,FormDatareq: any, trackLoading: boolean = true) => {
    
  try {
    const response: any = await fetch(baseUrl, {  method: 'POST', body: FormDatareq});          
    if (trackLoading) {
      this.PendingCalls--;
        this.HideSpinner();
      }
      const data = await response;
      return data;

} catch (error) {        
    if (trackLoading) {
      this.PendingCalls--;
        this.HideSpinner();
      }        
 }
};

  
  
  private ShowSpinner = () =>  {
     
  }
  
  
  private HideSpinner = () =>  {
     
  }

 
}

export default ApiService;
